import React, { type ReactNode } from 'react';
import styled from 'styled-components';

import { Text, type TextProps } from '@companycam/slab-web';

import { ActionLink } from 'components/shared';

const HeaderContainer = styled.div`
  display: flex;
  padding-bottom: var(--cc_size_spacing_xl);
`;

const HeaderTextContainer = styled.div`
  display: 'flex';
  flex-direction: 'column';

  p {
    margin: 8px 0 0;
  }
`;

const HeaderTitle = styled(Text)<TextProps>`
  margin-right: 24px;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.25;
`;

type HeaderProps = {
  description?: ReactNode;
  hideModal: () => void;
  title: string;
};

const Header = ({ description = '', hideModal, title }: HeaderProps) => {
  return (
    <HeaderContainer>
      <HeaderTextContainer>
        <HeaderTitle as="h1" size="xl" family="heading">
          {title}
        </HeaderTitle>
        {description ? <p>{description}</p> : null}
      </HeaderTextContainer>
      <ActionLink className="modal-close-button" onClick={hideModal}>
        <i className="mdi mdi-close" />
      </ActionLink>
    </HeaderContainer>
  );
};

export default Header;
